import React from 'react'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { User } from '@/schema'
import { getAvatarColor, getUserInitials } from '@/utils/avatar'
import { cn, formatFullName } from '@/utils/common'

export interface UserAvatarProps {
  user: User
  size?: string
  className?: string
  showBorder?: boolean
  textSize?: string
  greyedOut?: boolean
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  size = 'size-10',
  className,
  showBorder = true,
  textSize = 'text-xs',
  greyedOut = false,
}) => {
  const fullName = formatFullName(user.first_name, user.last_name)
  const initials = getUserInitials(user)
  const colors = getAvatarColor(user.id)

  return (
    <Avatar
      className={cn(size, showBorder && 'border border-black/10', className)}
    >
      {user.avatar_url && <AvatarImage src={user.avatar_url} alt={fullName} />}
      <AvatarFallback
        className={cn(
          textSize,
          'font-medium',
          greyedOut ? 'bg-muted' : colors.bg,
          greyedOut ? 'text-muted-foreground' : colors.text
        )}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  )
}
